// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInMonths as fn } from "../differenceInMonths.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInMonthsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default differenceInMonthsWithOptions;
